import { Typography } from '@mui/material'

export default function Header({ header }) {
    return (
        <Typography m={1}> <b>{header}</b> </Typography>
    )
}
